export const DATETIME_FORMAT = "YYYY-MM-DD:hh:mm:ss a";
export const DATE_24_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const DATE_FORMAT = "YYYY-MM-DD";
export const SAMI_Product_Id = "4c25b978-1a10-47b0-a106-738950823649";
